module.exports = __webpack_public_path__ + "media/mypage/images/special/TIMES2022-a034209aa4f61cb9835424fed2f2448b.jpg";